import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import * as Styled from '../styles';

const ElementErrorSign = ({ tooltipMsg, dataFor }) => (
    <Styled.ElementErrorTd>
        <Styled.Info>
            <Styled.Icon
                data-tip
                data-for={dataFor}
                className="material-icons"
            >
                info_outline
            </Styled.Icon>

            <ReactTooltip className="react-tooltip-element-warning-wrapper" id={dataFor} place="bottom" effect="solid">
                <Styled.TooltipMsgSpan data-test-id="element-error-sign-message" data-multiline>{tooltipMsg}</Styled.TooltipMsgSpan>
            </ReactTooltip>

        </Styled.Info>
    </Styled.ElementErrorTd>
);

ElementErrorSign.propTypes = {
    tooltipMsg: PropTypes.string.isRequired,
    dataFor: PropTypes.string.isRequired,
};
export default ElementErrorSign;
